<template>
  <div class="se-die-result">
    <div class="se-die-result-title">Result</div>
    <div class="wrapper">
      <div class="button-bet">
        <new-bet-lot
          class="se-die-result-betlot"
          :key="o1"
          :type="o1"
          :odd="odd(o1)"
          :win="winCellNo === o1_win"
          :game="game"
          :gameType="game"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(o1)"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
      <div class="button-bet">
        <new-bet-lot
          class="se-die-result-betlot"
          :key="o2"
          :type="o2"
          :odd="odd(o2)"
          :win="winCellNo === o2_win"
          :game="game"
          :gameType="game"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(o2)"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
      <div class="button-bet middle">
        <new-bet-lot
          class="se-die-result-betlot"
          :key="o3"
          :type="o3"
          :odd="odd(o3)"
          :win="winCellNo === o3_win"
          :game="game"
          :gameType="game"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(o3)"
          @update-session-storage="onUpdateSessionStorage"
          size="middle"
        />
      </div>
      <div class="button-bet">
        <new-bet-lot
          class="se-die-result-betlot"
          :key="o4"
          :type="o4"
          :odd="odd(o4)"
          :win="winCellNo === o4_win"
          :game="game"
          :gameType="game"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(o4)"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
      <div class="button-bet">
        <new-bet-lot
          class="se-die-result-betlot"
          :key="o5"
          :type="o5"
          :odd="odd(o5)"
          :win="winCellNo === o5_win"
          :game="game"
          :gameType="game"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(o5)"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
    </div>
    <div class="se-die-result-container">
      <new-bet-lot
        v-for="item in games"
        class="se-die-result-betlot"
        :key="item"
        :type="item"
        :odd="odd(item)"
        :win="item === oe_win"
        :game="game"
        :gameType="game"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(item)"
        @update-session-storage="onUpdateSessionStorage"
        size="large"
      />
    </div>
    <div class="button-bets">
      <div class="se-die-first">
        <div class="se-die-result-title">First Button</div>
        <div class="se-die-result-container">
          <new-bet-lot
            v-for="item in lead"
            class="se-die-result-betlot"
            :key="item"
            :type="item"
            :odd="odd(item)"
            :win="item === lead_win"
            :gameType="game"
            :game="game"
            :game-data="gameData"
            :minutes-string="minutesString"
            :seconds-string="secondsString"
            :disallow-betting="disallowBetting"
            :stake-record-sum="stakeRecordSum(item)"
            @update-session-storage="onUpdateSessionStorage"
          />
        </div>
        <div class="se-die-result-title">Third Button</div>
        <div class="se-die-result-container">
          <new-bet-lot
            v-for="item in third"
            class="se-die-result-betlot"
            :key="item"
            :type="item"
            :win="item === third_win"
            :odd="odd(item)"
            :gameType="game"
            :game="game"
            :game-data="gameData"
            :minutes-string="minutesString"
            :seconds-string="secondsString"
            :disallow-betting="disallowBetting"
            :stake-record-sum="stakeRecordSum(item)"
            @update-session-storage="onUpdateSessionStorage"
          />
        </div>
      </div>
      <div class="se-die-first">
        <div class="se-die-result-title">Second Button</div>
        <div class="se-die-result-container">
          <new-bet-lot
            v-for="item in second"
            class="se-die-result-betlot"
            :key="item"
            :type="item"
            :win="item === second_win"
            :odd="odd(item)"
            :gameType="game"
            :game="game"
            :game-data="gameData"
            :minutes-string="minutesString"
            :seconds-string="secondsString"
            :disallow-betting="disallowBetting"
            :stake-record-sum="stakeRecordSum(item)"
            @update-session-storage="onUpdateSessionStorage"
          />
        </div>
        <div class="se-die-result-title">Last Button</div>
        <div class="se-die-result-container">
          <new-bet-lot
            v-for="item in last"
            class="se-die-result-betlot"
            :key="item"
            :type="item"
            :win="item === last_win"
            :odd="odd(item)"
            :gameType="game"
            :game="game"
            :game-data="gameData"
            :minutes-string="minutesString"
            :seconds-string="secondsString"
            :disallow-betting="disallowBetting"
            :stake-record-sum="stakeRecordSum(item)"
            @update-session-storage="onUpdateSessionStorage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Row, Col, Button } from "iview";
import NewBetLot from "../../commons/NewBetLot";
import betLotMixin from "../../../mixins/bet-lot-mixin";

export default {
  mixins: [betLotMixin],
  props: ["game", "winCellNo", "gameData", "drawResult"],
  components: {
    Row,
    Col,
    Button,
    NewBetLot
  },
  data() {
    return {
      games: ["o6", "o7"],
      lead: ["o8", "o9"],
      second: ["o10", "o11"],
      third: ["o12", "o13"],
      last: ["o14", "o15"],
      o1: "o1",
      o2: "o2",
      o3: "o3",
      o4: "o4",
      o5: "o5",
      oe_win: 0,
      lead_win: 0,
      second_win: 0,
      third_win: 0,
      last_win: 0,
      o1_win: 0,
      o2_win: 0,
      o3_win: 0,
      o4_win: 0,
      o5_win: 0
    };
  },
  watch: {
    drawResult() {
      this.oe_win = "o" + this.drawResult.oe;
      this.lead_win = "o" + this.drawResult.lead;
      this.second_win = "o" + this.drawResult.second;
      this.third_win = "o" + this.drawResult.third;
      this.last_win = "o" + this.drawResult.last;
      this.o1_win = "o" + this.drawResult["4W0R"];
      this.o2_win = "o" + this.drawResult["3W1R"];
      this.o3_win = "o" + this.drawResult["2W2R"];
      this.o4_win = "o" + this.drawResult["1W3R"];
      this.o5_win = "o" + this.drawResult["0W4R"];
    }
  }
};
</script>

<style lang="scss" scoped>
.se-die-result {
  width: 100%;
}

.se-die-first {
  width: 50%;
}

.button-bets {
  width: 100%;
  display: flex;
  padding-bottom: 5px;
  background: #e5eaf8;
}

.wrapper {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-around;
  height: 100px;
  width: 100%;
  position: relative;
  padding-left: 1.5%;
  padding-top: 1%;
}

.button-bet {
  width: 32%;
  flex: 0 0 35px;
  border-radius: 5px;
  display: flex;
}

.middle {
  flex-basis: 92px;
}

.se-die-result-title {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #1c3a67;
  font-weight: bold;
  color: white;
  font-size: 12px;
  height: 25px;
  line-height: 25px;
}

.se-die-result-container {
  display: flex;
  padding: 5px;
  padding-top: 3px;
  height: 48px;
  background: #e5eaf8;
}

.se-die-result-betlot {
  background: #ffffff;
  flex: auto;
  height: 100%;
  border-radius: 5px;
}

.se-die-result-betlot:hover {
  background: #f5eeb8;
  cursor: pointer;
}

// .se-die-result-betlot:first-of-type {
//   margin-left: unset;
//   border-radius: 5px 0 0 5px;
// }

// .se-die-result-betlot:last-of-type {
//   margin-right: unset;
//   border-radius: 0 5px 5px 0;
// }
</style>
